import React from 'react'

const NoPage = () => {
  return (
    <div>
      ethbeteth
    </div>
  )
}

export default NoPage
